<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div id="header">
  <div id="head_left">
    <div>
      <span>[ </span>
      <span i18n>Analysis ID</span>
      <span>:{{ displayAnalysisId }} ]</span>&nbsp;
      <span>[ </span>
      <a [href]="summarylink" target="_blank" rel="noopener">{{ displaySampleName }}</a>
      <span> ]</span>
    </div>
    <div>
      <label>
        <input
          id="chkHighLightInverted"
          type="checkbox"
          [value]="false"
        >
        <span i18n>Highlight inverted molecules</span>
      </label>
    </div>
    <div>
      <label>
        <input
          id="chkInvertedDrawing"
          type="checkbox"
          [value]="false"
          [checked]="isInvertedDrawing"
        >
        <span i18n>Inverted Drawing</span>
      </label>
    </div>
  </div>
  <div id="svfilterButton">
    <button
      mat-stroked-button
      [matBadge]="badge.value"
      [matBadgeHidden]="badge.hidden"
      (click)="onFilterClick()"
    >
      <span i18n>Filter</span>
    </button>
  </div>
  <div id="head_right">
    <button id="zoom_out" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_out</mat-icon>
    </button>
    <button id="zoom_fix" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_out_map</mat-icon>
    </button>
    <button id="zoom_in" mat-icon-button>
      <mat-icon class="icon-hover material-icons-outlined material-symbols-outlined">zoom_in</mat-icon>
    </button>
    <div>
      <label for="posset" i18n>Jump to</label>
      <input type="text" id="posset" autocomplete="off">
      <span>kbp</span>
    </div>
  </div>
</div>
<div id="main">
  <div #canvasHost></div>
</div>
<div class="pURL">
  <span id="copyLink" (click)="onCopyLinkClick($event)" i18n>Click to copy shareable link</span>
  <div id="copyBalloon" i18n>Copied!</div>
</div>
<div id="footer"></div>

